import { StateSetter } from 'react';
import { useLang } from 'hooks/lang';

import { IconButton, Card, Table, Box, Tag } from 'components/Blocks';

import { PencilIcon } from 'components/Icons';

import { ProjectTagStatus } from './Status';

import { scrollToWrapperTop } from 'utils/html';
import { bestEffortSortCompare } from 'utils/array';

import { useTeamProfile } from '../context';
import { ProjectTag } from 'entities';

export function ProjectTagsTable({
  setFocusedTag,
}: {
  setFocusedTag: StateSetter<ProjectTag | null>;
}) {
  const { team, canMutateEntities } = useTeamProfile();

  const { t } = useLang();

  return (
    <Card>
      <Table
        items={team.projectTags}
        uniqueKey="id"
        itemsPerPage={20}
        columns={[
          {
            className: 'w-12',
            render: (tag) => <ProjectTagStatus tag={tag} />,
            sort: true,
            sorter: (a, b) => bestEffortSortCompare(b.disabled, a.disabled),
          },
          {
            className: 'w-12',
            label: t('color'),
            render: (tag) => <Box size={18} backgroundColor={tag.color} border="rounded" />,
          },
          {
            label: t('name'),
            property: 'name',
            sort: true,
            search: true,
          },
          {
            label: t('preview'),
            render: (tag) => <Tag {...tag} className="text-white" />,
          },
          {
            className: 'w-12',
            hide: !canMutateEntities,
            render: (tag) => (
              <IconButton
                tooltipContent={t('update')}
                onClick={() => {
                  setFocusedTag(tag);
                  scrollToWrapperTop();
                }}
              >
                <PencilIcon size={14} />
              </IconButton>
            ),
          },
        ]}
      />
    </Card>
  );
}
